import classNames from 'classnames';
import { Img, Portal, svgSprite } from '../../../../hybrid/wrappers';
import css from './CantBuyModal.module.scss';
import T from '../../../../common/components/T';
import SingleButton from '../../../../widgets/form/form-control-buttons/SingleButton/SingleButton';
import { useContext } from 'react';
import UserContext from '../../../../common/utils/getContext';
import { navigateV2 } from '../../../../common/utils/router';

export default function CantBuyModal({ closeHandler }) {
    const { setState } = useContext(UserContext);
    return (
        <Portal closeHandler={closeHandler}>
            <div className={css.modal}>
                <div onClick={closeHandler} className={classNames('circleButton', css.modalClose)}>
                    {svgSprite('cross')}
                </div>
                <Img src='/src/img/plugs/cant_buy.svg' alt='Cant buy' />
                <p className={css.modalTitle}>
                    <T textName='you_cant_buy_now' defaultStr='Пока вы не можете купить товар' page='/store' />
                </p>
                <p className={css.modalText}>
                    <T
                        textName='you_cant_buy_now_text'
                        defaultStr='Покупка товара доступна только зарегистрированным пользователям. Войдите в свой аккаунт или зарегистрируйтесь.'
                        page='/store'
                    />
                </p>
                <div className={css.buttons}>
                    <SingleButton
                        type='cancel'
                        buttonText={<T textName='login' defaultStr='Войти' />}
                        clickFunc={() => {
                            setState('showRegWindow', true);
                            closeHandler();
                        }}
                        customButton={{
                            butWrapper: css.buttonWrapper
                        }}
                    />
                    <SingleButton
                        type='ok'
                        buttonText={<T textName='register' defaultStr='Зарегистрироваться' />}
                        clickFunc={() => {
                            navigateV2('/auth/register');
                            closeHandler();
                        }}
                        customButton={{
                            butWrapper: css.buttonWrapper
                        }}
                    />
                </div>
            </div>
        </Portal>
    );
}
